<template>
  <div>
    <router-link to="/" class="logotype">
      <img src="../assets/images/ueg_logo.svg" />
    </router-link>
    <div class="container">
      <div class="group">
        <h1 class="page-title has-text-centered">Login into your account</h1>
        <form @submit.prevent="login">
          <div class="group-wrap">
            <div class="field">
              <label class="label is-hidden">Username</label>
              <div class="control has-icons-left">
                <input
                  v-model="email"
                  class="input"
                  type="email"
                  placeholder="Username"
                />
                <span class="icon is-small is-left">
                  <i class="icon-user"></i>
                </span>
              </div>
            </div>

            <div class="field">
              <label class="label is-hidden">Password</label>
              <div class="control has-icons-left">
                <input
                  v-model="password"
                  type="password"
                  class="input"
                  placeholder="Password"
                />
                <span class="icon is-small is-left">
                  <i class="icon-password"></i>
                </span>
              </div>
            </div>

            <button type="submit" class="button is-primary button-submit">
              Login
            </button>
          </div>
          <p v-show="error" class="help is-danger">{{ error }}</p>
        </form>
        <div class="login-form-other-actions ">
          <!-- div>remeber me</div -->
          <router-link
            :to="{ name: 'forgot-password' }"
            class="forgot-password"
          >
            Forgot Password?
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      error: ''
    };
  },
  mounted() {
    if (this.isAuth) {
      this.$router.push('/');
    }
  },
  methods: {
    login() {
      this.axiosRequest('post', 'Auth/Login', {
        email: this.email,
        password: this.password
      })
        .then(response => {
          const token = response.data.authToken;
          const id = response.data.userID;

          localStorage.setItem('authToken', token);
          localStorage.setItem('userID', id);
          window.location.href = this.$route.query.redirect || '/';
          // this.$parent.initApp();
        })
        .catch(error => {
          // Do something with response error
          if (error.response.status === 400) {
            console.log('unauthorized, logging out ...');
            this.error = error.response.data.errors.map(e => e.message).join();
          }
        });
    }
  }
};
</script>

<style lang="scss">
.page-login {
  .group {
    width: 550px !important;
  }
  form {
    margin-top: 9rem;
  }
  .group-wrap {
    height: 160px;
    background: url('../assets/images/loginshape.svg') 0 0 no-repeat;
    position: relative;
    padding-right: 150px;
    padding-left: 70px;
    padding-top: 14px;

    .field {
      margin-bottom: 53px;
    }

    input {
      background: transparent;
      color: rgba(255, 255, 255, 0.3);
      font-size: 1.6rem;
      @include has-no-focus;
      border: none;
    }

    .icon {
      color: rgba(255, 255, 255, 0.3) !important;
      font-size: 2.2rem;
      width: 35px;
      height: 35px;
    }

    .button-submit {
      width: 110px;
      height: 110px;
      border-radius: 55px;
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -55px;
      font-size: 1.6rem;
    }
  }
  .login-form-other-actions {
    display: flex;
    justify-content: space-evenly;
    margin: 5rem 0 8.75rem;
  }
  .forgot-password {
    font-size: 1.6rem;
  }
  .help {
    font-size: 1.5rem;
    text-align: center;
    padding-top: 10px;
  }
}
</style>
